<host-calendar
  class="month-calendar"
  [showYear]="_currentYear"
  [showMonth]="_currentMonth"
  [showPicker]="false"
  [weekLines]="6"
  (monthChange)="monthChange.emit($event)"
>
  <ng-template #header let-listOfWeekName>
    <div
      class="column-header border-b border-r last:border-r-0 border-solid border-[#E2E5E9] text-[#34383c] text-[14px] text-center"
      [class.weekend]="i === 5 || i === 6"
      *ngFor="let day of listOfWeekName; let i = index"
    >
      {{ day }}
    </div>
  </ng-template>
  <ng-template #cell let-day>
    <div class="cell-wrapper relative">
      <div
        *ngIf="!day.isLastMonth && !day.isNextMonth"
        class="cell-body bg-[length:100%_100%]"
        [ngClass]="{
          'selected-head': isHead(day.date),
          'selected-last': isLast(day.date),
          selected: isBetween(day.date),
          'bg-[url(/assets/calendar/shadow.png)]': calendarMap[day.title]?.inventory === 0
        }"
        (click)="toggleSelecting(day)"
        (mouseover)="updateSelectedDates(day)"
      >
        <span
          class="date"
          [class.weekend]="day.dayOfWeek === 0 || day.dayOfWeek === 6"
          [class.another-month]="day.isLastMonth || day.isNextMonth"
          [class.today]="day.isCurrentDay"
          [class.holiday]="day.holidayName"
        >
          {{
            day.isCurrentDay ? ("word.today" | translate) : isInternational ? day.number : day.holidayName || day.number
          }}
        </span>
        <span class="rest-token" [class.work]="day.isOff" *ngIf="day.isLegalHoliday || day.isOff">
          {{ (day.isLegalHoliday ? "word.rest" : "word.work") | translate }}
          <!-- 休 -->
        </span>

        <!-- 规则图标 -->
        <div
          class="rules-icons"
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverContent]="rulePopTpl"
          *ngIf="calendarMap[day.title]?.setting"
        >
          <div class="rules-item" *ngIf="calendarMap[day.title]?.setting?.showMoon">
            <img class="rules-icon" src="/assets/v4/icon-calendar-moon.svg" alt="" />
            <span class="text-[10px] text-[#586167]">{{ calendarMap[day.title]?.setting?.moonCount }}</span>
          </div>
          <div class="rules-item" *ngIf="calendarMap[day.title]?.setting?.showLock">
            <img class="rules-icon" src="/assets/v4/icon-calendar-lock.svg" alt="" />
          </div>
          <div class="rules-item" *ngIf="calendarMap[day.title]?.setting?.showFlag">
            <img class="rules-icon" src="/assets/v4/icon-calendar-flag.svg" alt="" />
          </div>
        </div>

        <span class="price">
          {{ calendarMap[day.title]?.price }}
        </span>

        <div
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverContent]="operatePop"
          [nzPopoverTrigger]="null"
          [nzPopoverPlacement]="'top'"
          [nzPopoverOverlayClassName]="'month-price-calendar-v2'"
          [nzPopoverVisible]="displayShortcutPop && selectStatus === 'done' && isLast(day.date)"
        ></div>

        <ng-template #operatePop>
          <div class="flex flex-row items-center divide-x divide-[#a2a2a2] divide-solid">
            <div class="item" *ngIf="dataOfShortcut.type === 0; else houseType" (click)="changeTab('channel-price')">
              {{ "component.month_calendar_v2.change_price" | translate }}
              <!-- 改价 -->
            </div>

            <div
              class="item"
              (click)="changeHouseAvailable(1, $event)"
              *ngIf="dataOfShortcut.status === 'diff' || dataOfShortcut.status === 'close'"
            >
              {{ "calendar.pop.status_on" | translate }}
              <!-- 打开 -->
            </div>
            <div
              class="item"
              (click)="changeHouseAvailable(0, $event)"
              *ngIf="dataOfShortcut.status === 'diff' || dataOfShortcut.status === 'open'"
            >
              {{ "calendar.pop.status_off" | translate }}
              <!-- 关闭 -->
            </div>
          </div>
          <ng-template #houseType>
            <div class="item" (click)="changeTab('channel-price')">
              {{ "component.month_calendar_v2.change_price" | translate }}
              <!-- 改价 -->
            </div>
            <div class="item" (click)="changeTab('channel-status')">
              {{ "component.month_calendar_v2.change_inventory" | translate }}
              <!-- 改库存 -->
            </div>
          </ng-template>
        </ng-template>

        <div class="operate-pop" *ngIf="false && displayShortcutPop && selectStatus === 'done' && isLast(day.date)">
          <div class="content">
            <div class="inner" *ngIf="dataOfShortcut.type === 0; else houseType">
              <div class="item" *ngIf="dataOfShortcut.type === 0; else houseType" (click)="changeTab('channel-price')">
                {{ "component.month_calendar_v2.change_price" | translate }}
                <!-- 改价 -->
              </div>

              <div
                class="item"
                (click)="changeHouseAvailable(1, $event)"
                *ngIf="dataOfShortcut.status === 'diff' || dataOfShortcut.status === 'close'"
              >
                {{ "calendar.pop.status_on" | translate }}
                <!-- 打开 -->
              </div>
              <div
                class="item"
                (click)="changeHouseAvailable(0, $event)"
                *ngIf="dataOfShortcut.status === 'diff' || dataOfShortcut.status === 'open'"
              >
                {{ "calendar.pop.status_off" | translate }}
                <!-- 关闭 -->
              </div>
            </div>
            <ng-template #houseType>
              <div class="inner">
                <div class="item" (click)="changeTab('channel-price')">
                  {{ "component.month_calendar_v2.change_price" | translate }}
                  <!-- 改价 -->
                </div>
                <div class="item" (click)="changeTab('channel-status')">
                  {{ "component.month_calendar_v2.change_inventory" | translate }}
                  <!-- 改库存 -->
                </div>
              </div>
            </ng-template>
            <div class="arrow"></div>
          </div>
        </div>

        <ng-template #rulePopTpl>
          <div>
            <!-- 规则-月亮 -->
            <div *ngIf="calendarMap[day.title]?.setting?.min_stay_on_arrival">
              {{ "calendar-rules_min_stay_on_arrival" | translate }}
              <!-- Min stay on arrival: -->
              {{ calendarMap[day.title]?.setting?.min_stay_on_arrival }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.min_stay_through">
              {{ "calendar-rules_min_stay_through" | translate }}
              <!-- Min stay through: -->
              {{ calendarMap[day.title]?.setting?.min_stay_through }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.max_stay_on_arrival">
              {{ "calendar-rules_max_stay_on_arrival" | translate }}
              <!-- Max stay on arrival: -->
              {{ calendarMap[day.title]?.setting?.max_stay_on_arrival }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.max_stay_through">
              {{ "calendar-rules_max_stay_through" | translate }}
              <!-- Max stay through: -->
              {{ calendarMap[day.title]?.setting?.max_stay_through }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.exact_stay_on_arrival">
              {{ "calendar-rules_exact_stay_on_arrival" | translate }}
              <!-- Exact stay on arrival: -->
              {{ calendarMap[day.title]?.setting?.exact_stay_on_arrival }}
            </div>
            <!-- 锁 -->
            <div *ngIf="calendarMap[day.title]?.setting?.closed_on_arrival">
              {{ "calendar-rules_closed_on_arrival" | translate }}
              <!-- Closed on arrival: -->
              {{ calendarMap[day.title]?.setting?.closed_on_arrival ? "Enabled" : "Disabled" }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.closed_on_departure">
              {{ "calendar-rules_closed_on_departure" | translate }}
              <!-- Closed on departure: -->
              {{ calendarMap[day.title]?.setting?.closed_on_departure ? "Enabled" : "Disabled" }}
            </div>

            <!-- 旗子 -->
            <div *ngIf="calendarMap[day.title]?.setting?.min_advance_res">
              {{ "calendar-rules_min_advance_res" | translate }}
              <!-- Min advance res: -->
              {{ calendarMap[day.title]?.setting?.min_advance_res }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.max_advance_res">
              {{ "calendar-rules_max_advance_res" | translate }}
              <!-- Max advance res: -->
              {{ calendarMap[day.title]?.setting?.max_advance_res }}
            </div>
            <div *ngIf="calendarMap[day.title]?.setting?.seasonal_rule">
              {{ "calendar-rules_seasonal_rule" | translate }}
              <!-- Seasonal rule: -->
              {{ calendarMap[day.title]?.setting?.seasonal_rule }}
            </div>
          </div>
        </ng-template>

        <ng-template #notePopTpl>
          <span class="note-pop-text">{{ calendarMap[day.title]?.note }}</span>
        </ng-template>

        <div
          class="reservation-bar"
          [class.head]="calendarMap[day.title]?.resvHead"
          [class.last]="calendarMap[day.title]?.resvLast"
          *ngIf="calendarMap[day.title]?.reservation"
        ></div>
      </div>
    </div>
  </ng-template>
</host-calendar>
